module.exports = __webpack_public_path__ + "img/log_1.ca73c952.png";